// Format number (1K, 1M, etc.)
export function formatNumber(num: number | undefined): string {
  if (!num) return '0';
  if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
  if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
  return num.toString();
}

// Format date (relative time in Chinese)
export function formatDate(timestamp: number | undefined): string {
  if (!timestamp) return '';

  const date = new Date(timestamp);
  const now = new Date();
  const diff = now.getTime() - date.getTime();

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (seconds < 60) return '刚刚';
  if (minutes < 60) return `${minutes}分钟前`;
  if (hours < 24) return `${hours}小时前`;
  if (days < 30) return `${days}天前`;
  if (months < 12) return `${months}个月前`;
  if (years < 10) return `${years}年前`;

  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

// Escape HTML to prevent XSS
export function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

// Format tweet text (convert URLs, hashtags, mentions)
export function formatTweetText(text: string): string {
  if (!text) return '';

  let formatted = escapeHtml(text);

  // Convert URLs
  formatted = formatted.replace(
    /(https?:\/\/[^\s]+)/g,
    '<a href="$1" target="_blank" rel="noopener" class="text-accent hover:underline">$1</a>'
  );

  // Convert hashtags
  formatted = formatted.replace(
    /#(\w+)/g,
    '<a href="https://twitter.com/hashtag/$1" target="_blank" class="text-accent hover:underline">#$1</a>'
  );

  // Convert mentions
  formatted = formatted.replace(
    /@(\w+)/g,
    '<a href="https://twitter.com/$1" target="_blank" class="text-accent hover:underline">@$1</a>'
  );

  return formatted;
}

// Default avatar SVG (data URI)
export const DEFAULT_AVATAR =
  'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%236e7681"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>';
